import LinkIcon from '@atlaskit/icon/core/link';
import { Inline, xcss } from '@atlaskit/primitives';
import { messages } from '@databases/intl/messages';
import { copyState, copyValueLink } from '@databases/selection-menu-actions';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS, type MenuItemBuilder } from '../types';

const elementBeforeIconWrapper = xcss({
  marginRight: 'space.negative.075',
});

export const copyValueLinkMenuItem: MenuItemBuilder = ({
  baseUrl,
  capabilities: { canCopyValue },
  contentId,
  databasePath,
  entryId,
  fieldId,
  formatMessage,
}) => {
  return {
    isEnabled: () => canCopyValue,
    menuItem: {
      key: SELECT_VALUE_MENU_ACTIONS.COPY_VALUE_LINK,
      content: formatMessage(messages['value-actions.copy-link']),
      onClick: () => {
        copyValueLink({
          baseUrl,
          contentId,
          databasePath,
          entryId,
          fieldId,
        });
      },
      closeOnClick: true,
      tooltipDescription: copyState.isCopied
        ? formatMessage(messages['copy-link.tooltip'])
        : undefined,
      tooltipPosition: 'right',
      elemBefore: (
        <Inline
          spread="space-between"
          alignBlock="center"
          xcss={elementBeforeIconWrapper}
        >
          <LinkIcon label="" spacing="spacious" />
        </Inline>
      ),
    },
  };
};
